{
  "appTitle": "Real Estate Tracker",
  "footer": "Real Estate Ad Tracker © 2026",
  "nav": {
    "ads": "Ads",
    "criteria": "Criteria",
    "mortgage": "Mortgage",
    "scraping": "Scraping",
    "administration": "Administration"
  },
  "userMenu": {
    "role": "Role: {{role}}",
    "logout": "Logout"
  },
  "logoutDialog": {
    "title": "Logout",
    "message": "Are you sure you want to logout?",
    "confirm": "Logout"
  },
  "language": {
    "label": "Language",
    "en": "English",
    "fr": "Français",
    "ro": "Română"
  },
  "formatters": {
    "notAvailable": "N/A",
    "invalidDate": "Invalid date",
    "justNow": "just now",
    "minuteAgo_one": "{{count}} minute ago",
    "minuteAgo_other": "{{count}} minutes ago",
    "hourAgo_one": "{{count}} hour ago",
    "hourAgo_other": "{{count}} hours ago",
    "dayAgo_one": "{{count}} day ago",
    "dayAgo_other": "{{count}} days ago",
    "weekAgo_one": "{{count}} week ago",
    "weekAgo_other": "{{count}} weeks ago",
    "monthAgo_one": "{{count}} month ago",
    "monthAgo_other": "{{count}} months ago",
    "yearAgo_one": "{{count}} year ago",
    "yearAgo_other": "{{count}} years ago",
    "roomStudio": "0.5 room (studio)",
    "room_one": "{{count}} room",
    "room_other": "{{count}} rooms",
    "today": "today",
    "yesterday": "yesterday"
  },
  "priceDisplay": {
    "tooltip": "Price changed from {{previous}} to {{current}} ({{when}})"
  },
  "aria": {
    "menu": "menu",
    "accountMenu": "account menu"
  },
  "errors": {
    "forbiddenTitle": "403 - Forbidden",
    "forbiddenMessage": "You do not have permission to access this page.",
    "notFound": "404 - Page Not Found"
  },
  "status": {
    "new": "New",
    "not_interested": "Not Interested",
    "interested_to_visit": "Interested to Visit",
    "visit_scheduled": "Visit Scheduled",
    "visited": "Visited",
    "discarded": "Discarded",
    "interested_to_buy": "Interested to Buy",
    "bought": "Bought",
    "retired": "Retired — No longer available"
  },
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "confirm": "Confirm",
    "back": "Back",
    "retry": "Retry"
  }
}
